import $ from "jquery"
import dispatchEventToReact from "scripts/utils/dispatchEventToReact"
import isDatepickerSupport from "scripts/utils/isDatepickerSupport"
import isMobileDevice from "scripts/utils/isMobileDevice"

export const initDatepicker_cert = (options = {}) => {
  const locale = $("html").attr("lang")

  const init = () => {
    function formatDate() {
      const date = new Date()

      date.setDate(date.getDate())
      date.setMonth(date.getMonth())
      date.setFullYear(date.getFullYear() - 18)
      return date
    }

    const calendar = $("#dateCalendar")
    if (calendar.length) {
      const updateSelect = () => {
        setTimeout(() => {
          window.customSelect.update(".ui-datepicker-month")
          window.customSelect.update(".ui-datepicker-year")
        }, 0)
      }
      const regional = $.datepicker.regional[locale] || $.datepicker.regional["en"]
      $.datepicker.setDefaults(regional)
      const fullmonth = regional.monthNames
      const date = $("#fullDate").val()
      const params = {
        changeMonth: true,
        changeYear: true,
        yearRange: `-100:-18`,
        dateFormat: "dd MM yy",
        monthNamesShort: fullmonth,
        maxDate: new Date(formatDate()),

        onSelect: () => {
          updateSelect()
        },
        onChangeMonthYear: () => {
          updateSelect()
        },
        ...options,
      }

      if (date !== "" && date !== undefined) {
        params.defaultDate = new Date(date)
      }

      calendar.datepicker(params)
      $(".ui-datepicker").addClass("notranslate")
      $("#dateCalendar").addClass("notranslate")
      updateSelect()
    } else {
      const date = $("#fullDate")
      if (date && date.val() !== "") {
        const value = date.val()
        const parseDate = new Date(value)
        const DatePickerFormat = $.datepicker.formatDate("dd MM yy", parseDate)

        $("#textDate").val(DatePickerFormat)
      }
    }
  }

  const calendarNav = () => {
    const saveButton = $(".save-calendar")
    const closeCalendar = $(".close-calendar")

    saveButton.on("click", () => {
      // const inputSelectorForWriteTextDate = $("#dateCalendar").data("for")
      // const fullDateInputId
      const hiddenDate = $.datepicker.formatDate(
        "yy-mm-dd",
        $("#dateCalendar").datepicker("getDate")
      )
      const calendarUi = document.getElementById("dateCalendar")
      const inputSelectorFullDate = calendarUi.dataset.for
      const fullDateInputEl = document.getElementById(inputSelectorFullDate)
      const textDateInputEl =
        fullDateInputEl.parentElement.querySelector(".js_input_text_date")

      const textDate = $.datepicker.formatDate(
        options.dateFormat || "dd MM yy",
        $("#dateCalendar").datepicker("getDate")
      )

      // Set value to full date input
      if (fullDateInputEl) {
        dispatchEventToReact(fullDateInputEl, hiddenDate, "change")
      }
    })

    closeCalendar.on("click", () => {
      $(".date-calendar").fadeOut(300)
    })
  }

  const showCalendar = () => {
    $(document)
      .on("keypress", "#textDate, .js_input_text_date", (e) => {
        e.preventDefault()
      })
      .on("click focus", "#textDate, .js_input_text_date", (e) => {
        const inputFullDate = e.target.parentElement.querySelector(".js_input_full_date")
        const dateCalendar = document.getElementById("dateCalendar")

        if (isDatepickerSupport() && isMobileDevice()) {
          // e.preventDefault();

          try {
            inputFullDate.showPicker()
            return
          } catch (error) {
            console.log("Datepicker error", error)
          }
        }
        const calendarHolder = $(".date-calendar")
        dateCalendar && (dateCalendar.dataset.for = inputFullDate.id)
        calendarHolder.fadeIn(300)
      })
    // .mouseup((e) => {
    //   const calendarHolder = $(".date-calendar")
    //   if (!calendarHolder.is(e.target) && calendarHolder.has(e.target).length === 0) {
    //     calendarHolder.fadeOut(300)
    //   }
    // })
  }

  init()
  calendarNav()
  showCalendar()
}
